<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t("terms") }}
    </h1>
    <span v-if="lang_Mix == 'slovakia'">
      <terms-slovak />
    </span>
    <span v-if="lang_Mix == 'czech'">
      <terms-czech />
    </span>
    <span v-else>
      <terms-english />
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import TermsSlovak from "./TermsSlovak";
import TermsEnglish from "./TermsEnglish";
import TermsCzech from "./TermsCzech";

export default {
  computed: mapGetters(["lang_Mix", "country_Mix"]),
  components: {
    TermsSlovak,
    TermsEnglish,
    TermsCzech,
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/miximo/Terms.vue